import { render, staticRenderFns } from "./SanctionEstado.vue?vue&type=template&id=409a6ab3&scoped=true&"
import script from "./SanctionEstado.vue?vue&type=script&lang=js&"
export * from "./SanctionEstado.vue?vue&type=script&lang=js&"
import style0 from "./SanctionEstado.vue?vue&type=style&index=0&id=409a6ab3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a6ab3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
})
